import React from "react";

import { Link } from "react-router-dom";
import { dataListsType } from "./featured-posts";
import LazyImage from "./lazyImage";

type Props = {
  props: dataListsType[];
};

const CardOverlap: React.FC<Props> = ({ props }) => {
  return (
    <>
      {props.map((item, key) => {
        return (
          <Link
            target="_top"
            to={{
              pathname: `/detailspage`,
              search: `?id=${item.id}&${item.category}/${item.urlinform}/`,
            }}
            key={key}
          >
            <div className="flex items-center justify-center mb-7 hover:text-[#5b68d3] transform transition-transform duration-500 ease-in-out hover:-translate-y-2 cursor-pointer">
              <div className="relative mr-4 w-[90px] h-[90px] flex-shrink-0">
                <LazyImage
                  src={item.images[0]}
                  alt={item.title}
                  className="w-full h-full object-cover rounded-md"
                />

                <span className="absolute top-1 left-1 w-[90px] h-[90px] bg-[#f8f6f6] rounded-md -z-10"></span>
              </div>
              <div className="flex flex-col justify-between py-0.5 h-[96px]">
                <span className="h-[52%] line-clamp-2">
                  <b className="text-sm font-semibold"> {item.title}</b>
                  <i className="text-opacity-0 text-[#c84e47] text-xs">
                    | Explore Asia
                  </i>
                </span>

                <span className="w-full h-[48%] text-[10px] text-[#363f4d] line-clamp-3">
                  {item.description}
                </span>
              </div>
            </div>
          </Link>
        );
      })}
    </>
  );
};

export default CardOverlap;
